{
    "TelephoneserverLabel": "Telephone Server:",
    "PartitionsLabel": "Partition(s):",
    "NAME": "ScopeFiltering",
    "ScopeFiltering_SectionHeader": "Scope Filtering"
}